import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocOverviewRoute: InvariantJiraRoute = {
	name: 'eoc-overview',
	path: '/jira/ops/overview',
	exact: true,
};
